import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import logo from '@/assets/drahft_logo.webp';
import heroImage from '@/assets/hero_max.webp';

const AUTH_QUOTES = [
  "We juggle weddings, home life, and everything in between. Admin shouldn't be the thing that keeps us up at night - that's what Drahft AI is for.",
  "We're balancing timelines, toddlers, and tired evenings. Admin shouldn't be another weight on our shoulders. Drahft AI lightens the load.",
  'Between family time and wedding season, our plates are full. Admin should not be the thing that tips it over. Drahft AI keeps it steady.',
  "We're running a business and a life at the same time. Admin shouldn't steal the moments that matter. Drahft AI gives them back.",
  "We're vendors, parents, partners, humans. Admin shouldn't be the part that burns us out. Drahft AI keeps the chaos calm.",
  "Our days are already packed with people we love and couples we care about. Admin shouldn't take us away from either. Drahft AI keeps it simple.",
  "We're juggling shoots, ceremonies, and school pickups. Admin shouldn't be the hardest part of the day. Drahft AI makes sure it isn't.",
  "Life is busy enough - weddings, family, everything in between. Admin shouldn't be the thing that drains our joy. Drahft AI brings the ease back.",
];

const AuthLayout = () => {
  const [quoteIndex, setQuoteIndex] = useState(0);
  const marketingUrl = import.meta.env.DEV ? 'http://localhost:3000' : 'https://drahft.com';

  useEffect(() => {
    const quoteTimer = window.setInterval(() => {
      setQuoteIndex(prev => (prev + 1) % AUTH_QUOTES.length);
    }, 6500);

    return () => window.clearInterval(quoteTimer);
  }, []);

  return (
    <div className="min-h-screen bg-white flex">
      <div className="flex-1 flex justify-center p-8 pt-12">
        <div className="flex w-full max-w-md min-h-[calc(100vh-6rem)] flex-col">
          <div className="flex justify-center mb-8 shrink-0">
            <img src={logo} alt="Drahft AI" className="h-12 w-auto" />
          </div>
          <div className="flex flex-1 items-center">
            <Outlet />
          </div>
          <p className="shrink-0 pt-6 text-center text-sm leading-relaxed text-gray-600">
            By creating an account, you agree to our{' '}
            <a
              href={`${marketingUrl}/terms`}
              target="_blank"
              rel="noopener noreferrer"
              className="underline transition-colors underline-offset-4 hover:text-primary-600"
            >
              Terms
            </a>{' '}
            and{' '}
            <a
              href={`${marketingUrl}/privacy`}
              target="_blank"
              rel="noopener noreferrer"
              className="underline transition-colors underline-offset-4 hover:text-primary-600"
            >
              Privacy
            </a>
            .
          </p>
        </div>
      </div>
      {/* Right side - Image placeholder */}
      <div className="hidden lg:flex flex-1 bg-neutral-dark relative">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${heroImage})` }}
        />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(255,255,255,0.25),_rgba(0,0,0,0.35)_65%)]" />
        <div className="absolute inset-0 flex items-center justify-center bg-night/30">
          <h3 className="text-white font-sans text-xl font-semibold text-center px-8 drop-shadow-lg">
            {AUTH_QUOTES[quoteIndex]}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
